/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React, { useEffect, useState } from "react"
import PropTypes from "prop-types"

import Seo from "@components/seo"

import * as styles from "./index.module.scss"
import { requestCurrentUser } from "@src/utils/request"
import AppContext from "@src/context/appContext"
import classnames from "@src/utils/classnames"
import { wxConfig, wxShare } from "@src/utils/wechat"
import { useBrowserLayout } from "gpages/hooks/layout"

const Layout = ({ children, location }) => {
  const [currentUser, setCurrentUser] = useState(null)
  useEffect(() => {
    requestCurrentUser().then((user) => {
      setCurrentUser(user)
    })

    wxConfig()
    wxShare()
  }, [])

  const { isMobileLayout, isWXBrowser } = useBrowserLayout()
  const isReady = typeof isMobileLayout === "boolean"

  return (
    <AppContext.Provider
      value={{
        currentUser,
        isMobileLayout,
        isWXBrowser,
      }}
    >
      <Seo />
      <div className={classnames(styles.fullscreen)}>
        {!isReady && (
          <div className={styles.loading}>
            <div>loading...</div>
          </div>
        )}
        <div
          className={classnames(styles.pagesContainer, {
            [styles.isReady]: isReady,
          })}
        >
          <div className={styles.body}>{children}</div>
        </div>
      </div>
    </AppContext.Provider>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
